<template>
	<b-container class="show-document">
		<b-modal id="modal-1"
				 title="BootstrapVue"
				 @ok="save($event)"
				 hide-header
				 @close="cancel"
				 @cancel="cancel"
				 :ok-title="$t('words.yes')"
				 :cancel-title="$t('words.no')"
				 v-model="showModal">
			<p v-if="pricingTrueOfFalse" class="my-4 text-center"><b>Изменение цены повлияет на все отдел!</b></p>
			<p class="my-4 text-center"><b>Вы уверены?</b></p>
			<b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
		</b-modal>

		<!--		<b-modal id="modal-1"-->
		<!--				 title="BootstrapVue"-->
		<!--				 @ok="update($event)"-->
		<!--				 hide-header-->
		<!--				 @close="cancel"-->
		<!--				 @cancel="cancel"-->
		<!--				 :ok-title="$t('words.yes')"-->
		<!--				 :cancel-title="$t('words.no')"-->
		<!--				 v-model="showModal">-->
		<!--			<p class="my-4">Вы уверены?</p>-->
		<!--			<b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>-->
		<!--		</b-modal>-->
		<div class="actions mb-2 mt-2 hidden-print">
			<b-spinner style="margin-left: 40%" v-if="loaders" variant="primary" label="Spinning"></b-spinner>
			<b-spinner style="margin-left: 40%" v-if="loadersShow" variant="primary" label="Spinning"></b-spinner>
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right" v-if="item.documentStatus === 'ADDED_EXTRA_COSTS'">
				<b-button
					variant="success"
					@click="showModalFunc()"
				>
					{{ $t('save-finish') }}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="doc-body">
			<b-card class="p-3">
				<b-row class="mb-3">
					<b-col cols="3">
						<b-input-group>
							<template #append>
								<b-input-group-text>
									<strong><i class="fa fa-search"/></strong>
								</b-input-group-text>
							</template>
							<b-form-input
								type="text"
								v-model="search.value"
							/>
						</b-input-group>
					</b-col>
					<b-col cols="1">

						<!--						<b-button @click="accept" class="pull-right" variant="primary"><i class="fas fa-search"></i>-->
						<!--						</b-button>-->
					</b-col>
					<b-col></b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center day-wrapper">
							{{ formatDate(item.regDate, 'DD') }}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center ">
							{{ formatDate(item.regDate, 'MM') }}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center">
							{{ formatDate(item.regDate, 'YYYY') }}
						</div>
					</b-col>
				</b-row>
				<div class="text-center">
					<h3 class="font-weight-bold text-uppercase">{{ $t(item.documentType) }} №: <span
						class="small">{{ item.regNumber }}</span>
					</h3>
					<b-button
						variant="success"
						size="sm"
						class="mb-2 mr-3"
						@click="addButton"
					>
						<i class="fas fa-file-upload"></i>
					</b-button>
					<download-excel :data="itemsForPriceExcel" class="btn btn-success mb-2 btn-sm" :name="`Продажная цена.xls`">
						{{ $t('excel-export.download-template') }}
					</download-excel>
				</div>

				<div class="generalTableClass documentItems">
					<!--					<b-progress v-if="showProgress" height="2px" :value="progressValue"></b-progress>-->
					<div class="progress" v-if="showProgress">
						<span class="progress-bar" :style="{width: progressValue+'%'}"></span>
					</div>
					<table class="table table-striped" id="whDocTable">
						<thead>
						<tr>
							<th class="p-1"> №</th>
							<th class="p-1">{{ $t('goods.name') }}</th>
							<th class="p-1">{{ $t('goods.create.special-barcode') }}</th>
<!--							<th class="p-1">{{ $t('goods.artikul') }}</th>-->
							<th class="p-1">{{ $t('goods.barcode') }}</th>
							<th class="p-1">{{ $t('kirim.expirationDate') }}</th>
							<th class="p-1">{{ $t('incomes.create.count') }}</th>
							<th class="p-1">{{ $t('incomes.incomeOldPrice') }}</th>
							<th class="p-1">{{ $t('incomes.retailOldPrice') }}</th>
							<th class="p-1">{{ $t('incomes.incomeNewPrice') }}</th>
							<th class="p-1">
								{{ $t('incomes.retailNewPrice') }}
								<!--								<b-row>-->
								<!--									<b-col cols="8">-->
								<!--									</b-col>-->
								<!--									<b-col cols="4">-->
								<!--										<b-button-->
								<!--											size="sm"-->
								<!--											class="mb-1"-->
								<!--											@click="clearNewPrices"-->
								<!--											style="color: #c8ced3"-->
								<!--										>-->
								<!--											<i class="fas fa-eraser" style="font-size: 20px; color: black"></i>-->
								<!--										</b-button>-->
								<!--									</b-col>-->
								<!--								</b-row>-->
							</th>
							<th class="p-1">{{ $t('pricing.dontChangePrice') }}
								<!--								<vs-checkbox @click='checkAll()' v-model='isCheckAll'/>-->
							</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(whItem,index) in item.whItems" :key="whItem.id + 'field'" v-if="whItem.count > 0">
							<td class="p-1">{{ paginate(index, search.limit + 1, search.page - 1) }}</td>

							<td class="p-1">{{ whItem.itemName ? whItem.itemName : '-' }}</td>
							<td class="p-1">{{ whItem.barcode ? whItem.barcode : '-' }}</td>
<!--							<td class="p-1">-</td>-->
							<td class="p-1">
								<div v-for="n in whItem.multiBarcodesString"> {{ n }}</div>
							</td>
							<td align="center" class="p-1">{{ whItem.termOfItem ? whItem.termOfItem : '-' }}</td>
							<td align="center" class="p-1">{{ whItem.count ? whItem.count : '-' }}</td>
							<td class="p-1">{{ whItem.currentIncomePrice ? whItem.currentIncomePrice : '-' }}</td>
							<td class="p-1">{{ whItem.currentPrice ? whItem.currentPrice : '-' }}</td>
							<td class="p-1">{{ whItem.newIncomePrice ? whItem.newIncomePrice : '-' }}</td>
							<th class="p-1">
								<b-col sm="12">
									<b-form-input
										v-model="whItem.priceUzs"
										@blur="updateWhItem(whItem.id, whItem)"
										type="number"
										id="input-large color" size="lg"
										:class="inputClassName(whItem.currentPrice, whItem.priceUzs)"
										:placeholder="priceForPlaceHolder(whItem.currentPrice)">
									</b-form-input>
								</b-col>
							</th>
							<th class="p-1">
								<b-col lg="12">
									<p v-if="whItem.currentPrice < 0">{{whItem.doNotInfluenceNewPriceToOlds}}</p>
									<vs-checkbox v-if="whItem.currentPrice >= 0"
												 type="checkbox"
												 :id="whItem.itemId"
												 :vs-value="whItem"
												 @click="updateWhItem(whItem.id, whItem)"
												 v-model="whItem.doNotInfluenceNewPriceToOlds"/>
								</b-col>
							</th>
						</tr>
						</tbody>
					</table>
					<b-row>
						<b-col cols="12" class="mt-3">
							<b-pagination :total-rows="total"
										  :per-page="search.limit"
										  v-model="search.page"
										  style="overflow-x: scroll"
										  :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')"
										  :limit="calculateLimit()"
										  size="lg"
										  hide-goto-end-buttons/>
						</b-col>
					</b-row>
				</div>
			</b-card>
			<b-form-file
				accept=".xlsx, xls"
				v-model="file"
				style="display: none"
				@change="processFile($event)"
				id="fileUpload"
			></b-form-file>
			<!--			<input style="display: none"  @change="processFile($event)" type="file" id="fileUpload">-->
		</div>

	</b-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import WhDocument from "@/services/wh-document.service";
import moment from "moment";

import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import warehouseDocument from "../../../../services/wh-document.service";
import GoodsService from "../../../../services/goods.service";
import XLSX from "xlsx";

export default {
	name: "Pricing",
	components: {
		XlsxWorkbook,
		XlsxSheet,
		XlsxDownload
	},
	data() {
		return {
			testCheck: false,
			root_api: process.env.VUE_APP_ROOT_API,
			publicPath: process.env.BASE_URL,
			loadersShow: true,
			file: null,
			excelName: 'test',
			inputFalse: false,
			dataForExcel: [],
			progressValue: 0,
			newPrice: 0,
			loading: false,
			viewPrices: 'not_accepted',
			loaders: false,
			showModal: false,
			item: {},
			checkedItems: [],
			total: 0,
			search: {
				page: 1,
				limit: 20,
				value: null
			},
			isArrowDown: true,
			totalPrice: {
				uzs: 0,
				usd: 0,
				saleTypePrice: 0,
				priceWholesale: 0,
				priceUzs: 0
			},
			priceType: 'uzs',
			income: [],
			totalIncome: {
				uzs: 0,
				usd: 0
			},
			confirmBarcodeGenerate: false,
			barcodeCount: 0,
			currentWhItems: [],
			sidebar: {
				open: false,
				close: false
			},
			backTo: null,
			isCheckAll: false,
			timer: null,
			showProgress: false
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		...mapActions('warehouse', ['setCurrentWhItems']),
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		calculateLimit() {
			if (this.total / this.search.limit - Math.floor(this.total / this.search.limit) > 0) {
				return '' + Math.floor(this.total / this.search.limit) + 1;
			}
			return '' + this.total / this.search.limit;
		},
		processFile(event) {
			this.showProgress = true
			var f = event.target.files[0];
			var mm = this
			var reader = new FileReader();
			var timout = 30;
			this.timer = setInterval(() => {
				this.progressValue += 10
				if (this.progressValue === 80 && timout === 30)
					this.progressValue = 70
				if (this.progressValue >= 100) {
					this.showProgress = false
					this.progressValue = 0
					this.clearInterval()
				}
			}, timout)
			reader.onload = (function (theFile) {
				return function (e) {
					var binaryData = e.target.result;
					var base64String = window.btoa(binaryData);
					mm.item.excelEncoded = base64String
					warehouseDocument.uploadExcel(mm.item)
						.then(res => {
							mm.get();
							// mm.item = Object.assign({}, res.data)
							timout = 100 / (100 - mm.progressValue)
							mm.progressValue += 1
							if (this.progressValue >= 100) {
								mm.showProgress = false
								mm.progressValue = 0
							}
							mm.file = null
						})
						.catch(e => {
							mm.get();
							mm.showProgress = false
							this.$vs.notify({
								title: e.response.data,
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
						});

				};
			})(f);
			reader.readAsBinaryString(f)
		},
		inputClassName(currentPrice, priceUzs) {
			if (priceUzs == '' && currentPrice == null) {
				return 'colorInput'
			}
			if (priceUzs !== undefined) {
				return ''
			}
			if (currentPrice == null) {
				return 'colorInput'
			}
		},
		priceForPlaceHolder(price) {
			if (price == null) return ''
			return '' + price;
		},
		clearInterval() {
			clearInterval(this.timer)
		},
		updateItemFromExcel(item) {
			this.item = item
		},
		addButton() {
			document.querySelector("#fileUpload").click()
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				this.loader = true;
				return WhDocument.getWithPrices(this.$route.params.id, this.search).then(response => {
					this.loader = false;
					this.item = response.data;
					this.total = response.data.totalPage;
				}).catch(error => {
					this.loader = false
				})
			}
		},
		updateWhItem(whItemId, whItem) {
			this.loading = true
			if (this.item.documentStatus == 'ADDED_EXTRA_COSTS')
				setTimeout(async () => {
					await WhDocument.updateWhItem(whItemId, whItem).then(response => {
						this.loading = false
					}).catch(error => {
						this.loader = false
					})
				}, 1000);
		},
		clearNewPrices() {
			this.item.whItems.forEach(whItem => {
				whItem.priceUzs = null
			})
		},
		cancel() {
			this.showModal = false
		},
		showModalFunc() {
			this.showModal = true
		},
		async save(bvModalEvt) {
			bvModalEvt.preventDefault()
			this.showModal = true
			this.loading = true
			setTimeout(async () => {
				await WhDocument.savePricingDoc(this.item.id).then(response => {
					this.item.documentStatus = status
					this.loader = true;
					this.item = response.data;
					this.loading = false
					this.showModal = false
					this.$router.back();
				}).catch(error => {
					this.showModal = false
					this.loading = false
					this.$bvToast.toast((this.isJson(error.request.response)
						? JSON.parse(error.request.response).message.substring(0, 120)
						: error.request.response + ` (${error.request.status}) - Something wrong, please try again`), {
						variant: 'danger',
						'no-close-button': false
					})
				})
			}, 1000);
		},
		isJson(str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},
		formatDate(date, format = 'DD-MM-YYYY') {
			if (date) {
				const split = date.split(' ');
				date = split[0];
				const revers = date.split('-');
				date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
				return moment(String(date)).format(format)
			}
		},
		checkAll() {
			for (let i = 0; i < this.item.whItems.length; i++) {
				if (this.item.whItems[i].currentPrice >= 0) {
					this.$set(this.item.whItems[i], 'checked', !this.isCheckAll)
					if (!this.isCheckAll)
						this.$set(this.item.whItems[i], 'priceUzs', this.item.whItems[i].currentPrice)
				}
			}
		},
		goBackToFrom() {
			this.$router.back();
		},
		arrowDown(arrowDown) {
			this.isArrowDown = arrowDown

			let len = this.item.whItems.length;
			let swapped;
			do {
				swapped = false;
				for (let i = 1; i < len; i++) {
					let curPrice = 0;
					let nextPrice = 0;
					if (this.item.whItems[i - 1].currentPrice !== undefined)
						curPrice = this.item.whItems[i - 1].currentPrice;

					if (this.item.whItems[i].currentPrice !== undefined)
						nextPrice = this.item.whItems[i].currentPrice;

					if (curPrice > nextPrice) {
						let tmp = this.item.whItems[i - 1];
						this.item.whItems[i - 1] = this.item.whItems[i];
						this.item.whItems[i] = tmp;
						swapped = true;
					}
				}
				len--;
			} while (swapped);

		},
		exportToExcel() {
			this.dataForExcel = []
			this.loading = true
			setTimeout(async () => {
				await WhDocument.getDocumentExcelWithPrices(this.item.id).then(response => {
					for (let j = 0; j < response.data.whItems.length; j++) {
						let data = {
							'Спец-код': response.data.whItems[j].barcode,
							'Количество': response.data.whItems[j].count,
							'Продажная цена': response.data.whItems[j].currentPrice,
							'Новая приходная цена': response.data.whItems[j].newIncomePrice,
							'Новая продажная цена': response.data.whItems[j].priceUzs
						}
						this.dataForExcel.push(data)
					}
					this.loading = false
				}).catch(error => {
					this.loading = false
				})
			}, 1000);
		},
		accept() {
			if (Object.keys(this.search).length !== 0) {
				this.$emit('search', this.search);
			} else
				this.$emit('search', {});
		},
	},
	created() {
		this.loadersShow = true
		this.get().then(res => {
			this.loadersShow = false
		});


	},
	watch: {
		'search.page': {
			handler() {
				this.get(this.search - 1);
			}
		},
		'search.value': {
			handler() {
				this.get(this.search - 1);
			}
		}
	},
	computed: {
		itemsForPriceExcel() {
			if (this.item.whItems) {
				let array = [];
				let temp;
				this.item.whItems.forEach(el => {
					temp = Object.assign(
						{},
						{
							"Спец-код": el.barcode,
							"Срок годности": el.termOfItem,
							"Новая продажная цена": el.currentPrice
						}
					);
					array.push(temp);
				});
				return array;
			}
		},
		pricingTrueOfFalse() {
			let tmp = false
			if (this.item.whItems) {
				this.item.whItems.forEach(item => {
					if (item.currentPrice) {
						if (item.priceUzs) {
							if (item.currentPrice != item.priceUzs) {
								tmp = true
							}
						}
					}
				})
			}
			return tmp
		}
	}
}


</script>

<style scoped lang="scss">
@media print {
	.hidden-print {
		display: none;
	}

	.card {
		box-shadow: none;
	}
}

.generalTableClass {
	.table {
		td, th {
			font-size: 12px;
		}
	}
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

* {
	box-sizing: border-box;
}

body {
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background: white;
}

.progress {
	width: 100%;
	max-width: 100%;
	height: 4px;
	background: #e1e4e8;
	border-radius: 3px;
	overflow: hidden;
}

.progress .progress-bar {
	display: block;
	height: 100%;
	background: linear-gradient(90deg, #ffd33d, #ea4aaa 17%, #b34bff 34%, #01feff 51%, #ffd33d 68%, #ea4aaa 85%, #b34bff);
	background-size: 300% 100%;
	-webkit-animation: progress-animation 2s linear infinite;
	animation: progress-animation 2s linear infinite;
}

@-webkit-keyframes progress-animation {
	0% {
		background-position: 100%;
	}
	100% {
		background-position: 0;
	}
}

@keyframes progress-animation {
	0% {
		background-position: 100%;
	}
	100% {
		background-position: 0;
	}
}

::placeholder {
	color: #4dbd74;
	text-align: center;
}

.colorInput {
	background-color: #ff686c;
}

</style>
